import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; 
import config from '../../config';

function EventsList() {
    const [events, setEvents] = useState([]);
    const [menus, setmenus] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-events`, { withCredentials: true });
            
            if(response.data){
                setEvents(response.data);
            }

        } catch (err) {
            setError('Failed to fetch locations');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    console.log("events: ", events);

    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Events</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total 
                                        <div className="count"> {events.length } Events</div>
                                    </div>
                                    <div className="project_search">
                                        <form action="">
                                            <input type="text" name="search" placeholder="Search projects" />
                                            <button type="submit" className="btn">Search</button>
                                        </form>
                                    </div>
                                    <div className="add_project">
                                    <Link to="/admin/add-event">Add Event</Link>
                                    </div>
                                </header>
                                <table className="projects-table">
                                    <thead>
                                        <tr>
                                            <th>Event Title</th>
                                            <th>Itineraries</th>
                                            <th className="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : (
                                            events.map((event, index) => ( 
                                                <tr key={event._id}>
                                                    <td><p>{event.title}</p></td>
                                                    <td><p>{`${event?.itineraryContent.length}`}</p></td>
                                                    <td><Link to={`/admin/event/${event._id}`} className="view_detail">View Details</Link></td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EventsList;
